function GradientDivider(){
    return(
        <>
        <div style={{height:'3px',width:'100%', backgroundImage:'linear-gradient(287deg, rgba(140,189,245,1) 30%, rgba(51,89,133,1) 50%, rgba(239,110,42,1) 70%)'}}></div>
        </>
    );

}
export default GradientDivider;